import {
  Shield,
  Target,
  Star,
  Globe,
  FileText,
  Share2,
  Search,
} from "lucide-react";

const iconMap: Record<string, React.ElementType> = {
  shield: Shield,
  target: Target,
  star: Star,
  globe: Globe,
  "file-text": FileText,
  share2: Share2,
  search: Search,
};

export function getRecommendationIcon(iconName: string, className = "w-4 h-4 text-brand-orange") {
  const Icon = iconMap[iconName] || Target;
  return <Icon className={className} />;
}
